<template>
	<div>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Pengiriman Transfer Stok</div>
		</div>
		<div class="pt-3" v-if="loading">
			<v-card elevation="0" width="1000" height="100">
				<template>
					<vcl :width="300" :height="25">
						<rect x="0" y="5" rx="1" ry="1" width="80" height="7" />
						<rect x="85" y="5" rx="1" ry="1" width="20" height="7" />
						<rect x="110" y="5" rx="1" ry="1" width="20" height="7" />
						<rect x="0" y="20" rx="1" ry="1" width="280" height="5" />
					</vcl>
				</template>
			</v-card>
			<v-card elevation="0" width="1000" height="65" v-for="i in 10" :key="i">
				<template>
					<vcl :width="300" :height="20">
						<rect x="0" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="0" y="11" rx="1" ry="1" width="50" height="5" />
						<rect x="70" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="70" y="11" rx="1" ry="1" width="50" height="5" />
						<rect x="140" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="140" y="11" rx="1" ry="1" width="50" height="5" />
						<rect x="210" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="210" y="11" rx="1" ry="1" width="50" height="5" />
					</vcl>
				</template>
			</v-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link v-if="hasAccess('add-transfer-stock-delivery')" :to="{ name: 'add-transfer-stock-delivery' }">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Pengiriman Transfer Stok</div>
							</v-btn>
						</router-link>
						<div class="ml-4">
							<v-tabs color="primary" background-color="deep-purple lighten-5" class="change-display" height="40">
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="teal lighten-1 mr-2" @click="changetype('in')">
							<v-icon color="white" v-if="transfer_type == 'in'">mdi-arrow-down-bold-box-outline</v-icon>
							<div class="pl-2 text-capitalize white--text">Masuk</div>
						</v-btn>
						<v-btn text depressed class="pink lighten-1 mr-2" @click="changetype('out')">
							<v-icon color="white" v-if="transfer_type == 'out'">mdi-arrow-up-bold-box-outline</v-icon>
							<div class="pl-2 text-capitalize white--text">Keluar</div>
						</v-btn>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-show="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Kode Transfer" v-model="tdo_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalTDO)" label="Tanggal Transfer" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalTDO"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="" outlined dense hide-details v-model="tdo_status.value" :items="TDOStatus" label="Status Transfer" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{ item | toStatusPDOWH }}
									</template>
									<template v-slot:selection = {item}>
										{{ item | toStatusPDOWH }}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="ml-2 text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table loading :headers="headers" :items="listTDO" hide-default-footer :options.sync="option" :server-items-length="tdoPagination.tdotal_data" disable-pagination>
					<template v-slot:item.tdo_status_created_datetime="{ item }">
						<div class="pt-2">{{ item.tdo_status_created_datetime | tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-btn x-small dense text color="grey darken-1" @click="printTDO(userData.user_warehouse_id, item.tdo_code)"><v-icon>mdi-printer</v-icon></v-btn>
						</div>
					</template>
					<template v-slot:item.tdo_code="{ item }">
						<div>{{ item.tdo_code }}</div>
					</template>
					<template v-slot:item.from_warehouse_name="{ item }">
						<div>{{ item.from_warehouse_name }}</div>
						<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.from_warehouse_mobilephone }}</span></div>
					</template>
					<template v-slot:item.to_warehouse_name="{ item }">
						<div>{{ item.to_warehouse_name }}</div>
						<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.to_warehouse_mobilephone }}</span></div>
					</template>
					<template v-slot:item.tdo_status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.tdo_status | toStatusPDOWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.tdo_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
							<v-tooltip bottom v-if="item.tdo_status == 'on_delivery' && item.tdo_destination == 'in' && hasAccess('receipt-transfer-delivery-order')">
								<template v-slot:activator="{ on, attrs }">
									<router-link class="text-deco" :to="{ name: 'receipt-transfer-delivery-order', params: { code: item.tdo_code }}" v-if="hasAccess('receipt-transfer-delivery-order')">
										<v-btn class="mr-1" fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
											<v-icon dark>mdi-check</v-icon>
										</v-btn>
									</router-link>
								</template>
								<span>Penerimaan Transfer</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!tdoPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card outlined v-if="listTDO.length == 0 && tdoPagination">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<v-card outlined v-else-if="listTDO.length == 0 && !tdoPagination">
					<div class="py-3">
						<loading-data></loading-data>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="tdo in listTDO" :key="tdo.po_id">
					<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Transfer# {{ tdo.tdo_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="primary" @click="printTDO(userData.user_warehouse_id, tdo.tdo_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Tanggal </div>
									<div class="subtitle-2">{{ tdo.tdo_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2>
									<div class="body-2 oppacity-75">Asal Pengiriman </div>
									<div class="subtitle-2">{{ tdo.from_warehouse_name }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2>
									<div class="body-2 oppacity-75">Tujuan Pengiriman</div>
									<div class="subtitle-2">{{ tdo.to_warehouse_name }}</div>
								</v-flex>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ tdo.tdo_status | toStatusPDOWH }}</div>
								</v-flex>
								<v-flex xs6 sm3 md2>
									<div>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(tdo.tdo_code)" class="mr-2">
													<v-icon dark>mdi-text-box-search</v-icon>
												</v-btn>
											</template>
											<span>Detail</span>
										</v-tooltip>
										<v-tooltip bottom v-if="tdo.tdo_status == 'on_delivery' && tdo.tdo_destination == 'in' && hasAccess('receipt-transfer-delivery-order')">
											<template v-slot:activator="{ on, attrs }">
												<router-link class="text-deco" :to="{ name: 'receipt-transfer-delivery-order', params: { code: tdo.tdo_code }}">
													<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
														<v-icon dark>mdi-check</v-icon>
													</v-btn>
												</router-link>
											</template>
											<span>Penerimaan Transfer</span>
										</v-tooltip>
									</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row v-if="tdoPagination">
					<v-spacer></v-spacer>
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" @input="changePage" :length="tdoPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalDetail from '@/views/MLwarehouse/tdo/DetailTDO'
import modalPrint from '@/views/MLwarehouse/tdo/PrintTDO'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: false,
			menu: false,
			loading: true,
			transfer_type: 'in',
			tanggalTDO: [],
			tdo_code: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'tdo_code'
			},
			tdo_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'tdo_status_created_datetime'
			},
			tdo_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'tdo_status'
			},
			sortBy: 'tdo_id',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			headers: [
			{ text: 'Tanggal', value: 'tdo_status_created_datetime' },
			{ text: 'Kode Transfer', sortable: true, value: 'tdo_code'},
			{ text: 'Asal Pengiriman', value: 'from_warehouse_name'},
			{ text: 'Tujuan Pengiriman', value: 'to_warehouse_name'},
			{ text: 'Status', value: 'tdo_status' },
			],
			params:[],
			procces_tdo_id: '',
			tdoProccess : '',
		}
	},
	computed: {
		...mapState('tdo', ['listTDO', 'tdoPagination', 'TDOStatus']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('tdo', ['getTDOIn', 'getTDOOut', 'getDetailTDO', 'getTDOStatus', 'exportTDO', 'exportTDOIN', 'exportTDOOUT']),
		...mapMutations('tdo', ['clearDataTDO']),
		...mapActions('common', ['getLetterHeader']),

		exportData(){
			if (this.transfer_type == 'in') {
				this.exportTDOIN(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else {
				this.exportTDOOUT(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		changetype(type) {
			this.transfer_type = type
			this.resetFilter()
		},
		getData() {
			if (this.transfer_type == 'in') {
				this.getTDOIn(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else {
				this.getTDOOut(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		resetFilter(){
			this.tdo_code.value = ''
			this.tdo_date.value = ''
			this.tdo_status.value = ''
			this.page = 1
			this.getData()
		},
		cari(){
			this.params = []
			if (this.tdo_code.value)
				this.params.push(this.tdo_code)
			if (this.tdo_date.value){
				if (this.tdo_date.value.length > 1) {
					this.tdo_date.value.sort()
					let date = this.tdo_date.value.join('::')
					this.tdo_date.value = date
				}
				this.params.push(Object.assign({}, this.tdo_date))
			}
			if (this.tdo_status.value)
				this.params.push(this.tdo_status)
			this.page = 1
			this.getData()
		},
		getDetail(code){
			this.getDetailTDO(code).then(()=> {
				this.dialog = true
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.page = 1
			this.limit = limit
			this.getData()
		},
		async printTDO(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailTDO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Pengiriman Transfer Stok`)
		await this.getData()
		await this.getTDOStatus()
		this.loading = await false
	},
	beforeDestroy() {
		this.clearDataTDO()
	},
	watch: {
		tanggalTDO(val) {
			this.tdo_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>